export default {
  vendedor: '',
  empresa: '',
  grupo: '',
  midia: ''
}
